const ITEMS = [
  "Acquisto oro e argento",
  "Rolex secondo polso",
  "Gioielli vintage",
  "Valutazione gratuita",
  "Pagamento immediato",
  "Orologi di prestigio",
];

export default function Marquee() {
  return (
    <div className="marquee overflow-hidden border-y border-gold/20 bg-[#080808] py-4" data-testid="editorial-marquee" aria-hidden="true">
      <div className="marquee-track">
        {[0, 1].map((copy) => (
          <div key={copy} className="flex shrink-0 items-center">
            {ITEMS.map((item, i) => (
              <span key={i} className="flex items-center">
                <span className="px-8 font-serif text-lg italic tracking-wide text-gold/80">{item}</span>
                <span className="text-gold/40">✦</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
